'use strict';

var accesoryPage = void 0;
var accesory = function () {
	// Variable que se usa para verificar si se tienen que recargar los precios al cambiar la mano de obra
	var toReload = false;
	var curRef = void 0; // Referencia actual
	var $curContainer = void 0;
	var _getRef = function _getRef() {
		return curRef;
	};
	var _getCurContainer = function _getCurContainer() {
		return $curContainer;
	};
	var _init = function _init() {
		// Indicamos que estamos en la página de accesorios, así se sabe que se debe recargar cuando se cambia el precio de MO
		accesoryPage = true;

		if (typeof accesorio !== 'undefined' && accesorio !== '') {
			_printAcc(accesorio.datos);
			_buildBreadCrumbs(accesorio.breadcrumbs);
		} else {
			console.error('lista de resultados no definida o vacía');
		}
	};

	var _buildBreadCrumbs = function _buildBreadCrumbs(bc) {
		$('.js-bc-0').attr('href', bc.link0);
		$('.js-bc-1').text(bc.nivel1.toUpperCase()).attr('href', bc.link1);
		$('.js-bc-2').text(bc.nivel2.toUpperCase()).attr('href', bc.link2);
	};

	var _printAcc = function _printAcc(datos) {
		var $container = $('.js-content-datos');

		toReload = !!$container;
		$curContainer = $container;
		curRef = datos.referencia;

		datos.slides.forEach(function (element) {
			$container.find('.js-slider').append('<div class="h-slide" style="background-image: url(' + element + ')"></div>');
		});

		_printData($container, datos);

		// Comprobamos si está en el carrito para marcar el checkbox
		var existsInCartList = cartList.matchRefAndMoi(datos.referencia, modelmoi);

		if (existsInCartList.length > 0) {
			$container.find('.js-add-cartlist').prop('checked', true);
		}

		$container.find('.js-add-cartlist').attr('data-ref', datos.referencia).on('change', function () {
			cartList.checkboxListener($(this));
		});

		datos.aplica.forEach(function (element) {
			$container.find('.js-aplica').append('<p>' + element + '</p>');
		});
		if (datos.excluye.length > 0) {
			datos.excluye.forEach(function (element) {
				$container.find('.js-excluye').append('<p>' + element + '</p>');
			});
		} else {
			$('.dato.excluye').hide();
		}

		if (datos.tecnica && datos.tecnica.trim() !== '') $('.js-tecnica .texto').text(datos.tecnica);else $container.find('.js-tecnica').hide();
		if (datos.incompatibilidades && datos.incompatibilidades.trim() !== '') $('.js-incompatibilidades .texto').text(datos.incompatibilidades);else $container.find('.js-incompatibilidades').hide();
		if (datos.comercial && datos.comercial.trim() !== '') $('.js-comercial .texto').text(datos.comercial);else $container.find('.js-comercial').hide();
		if (datos.acc_kit && datos.acc_kit.length > 0) {
			for (var i = 0; i < datos.acc_kit.length; i++) {
				$('.js-incluye .texto').append(datos.acc_kit[i] + '<br>');
			}
		} else {
			$container.find('.js-incluye').hide();
		}
		// if(datos.legales.trim() !== '') $('.js-legales .texto').text(datos.legales)
		// else $container.find('.js-legales').hide()
		if (datos.legales.trim() == 0) $container.find('.js-legales').hide();

		if (datos.documentacion.length > 0) {
			$('.js-documentos .documento').hide();
			datos.documentacion.forEach(function (element) {
				var extension = element.link.split('.');
				extension = extension[extension.length - 1];
				$container.find('.js-documentos .js-' + element.nombre).attr('href', element.link).addClass(extension).show();
			});
		} else {
			$('.aop-docs').hide();
		}
	};

	var _printData = function _printData($container, datos) {
		$container.find('.js-referencia').text(datos.referencia);
		$container.find('.js-nombre').text(datos.nombre);
		if (datos.descripcion.trim() === '') {
			$('.js-descripcion-titulo').css({ visibility: 'hidden' });
		} else {
			$container.find('.js-descripcion').text(datos.descripcion);
		}

		$container.find('.js-pvp').text(parseFloat(datos.pvp).toLocaleString('es-ES'));
		$container.find('.js-pvc').text(parseFloat(datos.pvc).toLocaleString('es-ES'));
		$container.find('.js-mc').text(parseFloat(datos.mc).toLocaleString('es-ES'));
		$container.find('.js-tm').text(datos.tm);
	};

	var _reload = function _reload() {
		if (toReload) {
			var ref = _getRef();
			var $container = _getCurContainer();
			$.ajax({
				dataType: 'json',
				url: location.pathname + '?pMode=reloadAccesorio&ref=' + ref + '&moi=' + modelmoi,
				success: function success(jsondata) {
					_printData($container, jsondata.datos);
				}
			});
		}
	};

	return {
		init: _init,
		reload: _reload
	};
}();